export const lastOrDefaultAsync = async (source, predicate) => {
    const dataFunc = source.dataFunc;
    switch (dataFunc.type) {
        case 0: {
            const values = await dataFunc.generator();
            for (let i = values.length - 1; i >= 0; i--) {
                const value = values[i];
                if (await predicate(value) === true) {
                    return value;
                }
            }
            break;
        }
        case 1: {
            const promises = dataFunc.generator();
            for (let i = promises.length - 1; i >= 0; i--) {
                const value = await promises[i];
                if (await predicate(value) === true) {
                    return value;
                }
            }
            break;
        }
        case 2: {
            const promises = await dataFunc.generator();
            for (let i = promises.length - 1; i >= 0; i--) {
                const value = await promises[i];
                if (await predicate(value) === true) {
                    return value;
                }
            }
            break;
        }
    }
    return null;
};
